var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-pool-view"},[(_vm.question)?_c('div',[_c('Question',{attrs:{"question":_vm.question},on:{"answered":_vm.handleAnswer,"failed":_vm.handleWrongAnswer}})],1):_vm._e(),(_vm.loading)?_c('Spinner'):(
      _vm.$route.meta.pageType == 'wrong-questions' && _vm.questions.length == 0
    )?_c('p',[_vm._v("\n    Alle Fragen korrekt beantworetet!\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }